export default __webpack_public_path__ + "static/media/export.b4545d54.svg";